// extracted by mini-css-extract-plugin
export var container = "_ct-0";
export var popoverContent = "_ct-1";
export var tosLink = "_ct-2";